module.exports = __webpack_public_path__ + "static/img/positive_bg.7c8b20b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/positive_bg.png
// module id = +W0y
// module chunks = 14